import { Subject } from "rxjs";
import { ToastInterface, Severities } from "../../interfaces";

export abstract class ToastAbstraction {
  notificationChange: Subject<ToastInterface> = new Subject<ToastInterface>();
  abstract notify(severity: Severities, summary: string, detail: string, viewToast: boolean, timeLife?: number): void
}
